/**
 * landing-icons.ts — mapper ikon-ID (LandingIconId) til Carbon-piktogrammer
 *
 * ibm.com bruker pictograms i produktkort; samme gjør vi her. Eksportnavnene
 * er verifisert mot @carbon/pictograms-react (mappe lib/<navn>/).
 */

import {
  AccessManagement,
  Api,
  Code,
  Containers,
  DataStorage,
  DataTransfer,
  FilterAndGroupData,
  Globe,
  Firewall,
  Scalable,
  VirtualServer,
  Automobile,
  ChipCircuit,
  Conversation,
  FileTransfer,
  Tools,
  Workflows,
  Ai,
  Analytics,
  Building,
  Calendar,
  Colors,
  CustomerService,
  DataBackup,
  DataSecurity,
  Database,
  Folder,
  Group,
  KeyUsers,
  Magnify,
  Envelope,
  Notifications,
  Servers,
  ShoppingCart,
  Speedometer,
  Websites,
} from '@carbon/pictograms-react';
import type { ComponentType } from 'react';
import { NodeJsLogo, WordPressLogo } from './brand-logos';
import type { LandingIconId } from '@/types/landing';

type CarbonPictogram = ComponentType<{ className?: string; 'aria-hidden'?: boolean }>;

export const LANDING_ICONS: Record<LandingIconId, CarbonPictogram> = {
  files: Folder,
  rental: Calendar,
  ads: Analytics,
  crm: Group,
  admin: KeyUsers,
  ai: Ai,
  access: AccessManagement,
  tenant: Building,
  realtime: Notifications,
  theme: Colors,
  speed: Speedometer,
  security: DataSecurity,
  backup: DataBackup,
  support: CustomerService,
  database: Database,
  domain: Websites,
  mail: Envelope,
  server: Servers,
  vehicle: Automobile,
  transfer: FileTransfer,
  chat: Conversation,
  workshop: Tools,
  dealer: Building,
  process: Workflows,
  chip: ChipCircuit,
  virtual: VirtualServer,
  code: Code,
  firewall: Firewall,
  scalable: Scalable,
  containers: Containers,
  api: Api,
  storage: DataStorage,
  globe: Globe,
  search: Magnify,
  buy: ShoppingCart,
  move: DataTransfer,
  list: FilterAndGroupData,
  wordpress: WordPressLogo,
  nodejs: NodeJsLogo,
};
